import axios from "axios";

export const API_URL = `${process.env.REACT_APP_API_URL}/bintypes`;

// CREATE =>  POST: add a new product to the server
export function createBinType(bintype) {
    return axios.post(API_URL, { ...bintype });
}

// READ
export function getAllBinTypes() {
    return axios.get(API_URL);
}

export function getPaginatedBinTypes(queryParams) {
    return axios.post(`${API_URL}/list`, { ...queryParams });
}

export function getBinTypeById(bintypeId) {
    return axios.get(`${API_URL}/${bintypeId}`);
}



// // Method from server should return QueryResultsModel(items: any[], totalsCount: number)
// // items => filtered/sorted result
// export function findProducts(queryParams) {
//     return axios.post(`${API_URL}/find`, { queryParams });
// }

// UPDATE => PUT: update the bintype on the server
export function updateBinType(bintypeId, bintype) {
    return axios.put(`${API_URL}/${bintypeId}`, { ...bintype });
}


// DELETE => delete the product from the server
export function deleteBinType(bintypeId) {
    return axios.delete(`${API_URL}/${bintypeId}`);
}
